export default __webpack_public_path__ + "static/media/fontsWaterMarks.0ed9e56f.svg";